var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header-logo-container" }, [
    _c("img", {
      attrs: {
        alt: _vm.getStoreName + " image",
        src: require("../../../assets/store-logo.png")
      },
      on: { load: _vm.logoLoaded }
    }),
    _vm._v(" "),
    _c(
      "p",
      { staticClass: "header-location", on: { click: _vm._navigateToLocator } },
      [_vm._v("\n\t\t" + _vm._s(_vm.displayStoreLocation) + "\n\t")]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a6844b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a6844b2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/NavigationItems/HeaderLogoLocation.vue
// module id = null
// module chunks = 